import { AIScanFoodOptionType } from "model/food/types"
import {
  getNutritionPayload,
  getPortionUnitPayload,
} from "./getBaseMealPayloadFromFood"
import {
  IAINutritionFactPayload,
  IAIPackageMealPayload,
  IAIScanMealPayload,
  ICreateMealPayload,
} from "model/food/types/mealPayload.types"
import { getEdamaMealPayloadFromFood } from "./getEdamaMealPayload"
import { LogMealType } from "model/food/types/base.types"
import { getMyMealPayloadFromFood } from "./getMyMealPayloadFromFood"
import { IScannedFoodUploadedImageDict } from "features/meal/mealSlice.types"
import {
  IAIScanFoodOption,
  IAIScanNutritionFactOption,
  IAIScanPackageFoodOption,
} from "model/food/types/AIScan.types"
import { getOpenFoodFactMealPayloadFromFood } from "./getOpenFoodFactMealFromFood"

type AIScanImageInput = {
  imageFile?: File
  imageId?: string
  imageUrl?: string
  previewImageUrl?: string
}

type AIScanImagePayload =
  | { image: File }
  | { imageId: string }
  | { imageUrl: string; previewImageUrl?: string }

const getAIScanImagePayload = ({
  imageFile,
  imageId,
  imageUrl,
  previewImageUrl,
}: AIScanImageInput): AIScanImagePayload | undefined => {
  if (imageFile) {
    return { image: imageFile }
  }

  if (imageId) {
    return { imageId }
  }

  if (imageUrl) {
    return { imageUrl, ...(previewImageUrl && { previewImageUrl }) }
  }

  return undefined
}

const getAIScanBasePayload = (
  food:
    | IAIScanFoodOption
    | IAIScanPackageFoodOption
    | IAIScanNutritionFactOption,
  imagePayload: any,
) => ({
  foodId: food.id!,
  name: food.name,
  ...getNutritionPayload(food),
  ...getPortionUnitPayload(food),
  ...getAIScanImagePayload(imagePayload),
})

const getMealPayloadFromAIScanFoodOption = ({
  food,
  logMealType,
  uploadedImageDict,
}: {
  food: AIScanFoodOptionType
  logMealType?: LogMealType
  uploadedImageDict: IScannedFoodUploadedImageDict
}): ICreateMealPayload | undefined => {
  let imagePayload = uploadedImageDict[food.id]
  switch (food.source) {
    case "EDAMAM":
      const edamaPayload = getEdamaMealPayloadFromFood(food, logMealType)
      return edamaPayload

    case "OPEN_FOOD_FACTS":
      const openFoodFactPayload = getOpenFoodFactMealPayloadFromFood(food, logMealType)
      return openFoodFactPayload

    case "MY_FOOD":
      const myMealPayload = getMyMealPayloadFromFood(food, logMealType)
      return myMealPayload

    case "AI_SCAN_MEAL":
      const payload: IAIScanMealPayload = {
        ...getAIScanBasePayload(food, imagePayload),
        source: "AI_SCAN_MEAL",
        type: logMealType,
        ingredients: food.ingredients.map(({ uuid, ...ingredient }) => {
          return {
            ...ingredient,
          }
        }),
      }

      return payload

    case "AI_SCAN_PACKAGE":
      const AIPackedPayload: IAIPackageMealPayload = {
        ...getAIScanBasePayload(food, imagePayload),
        source: "AI_SCAN_PACKAGE",
        type: logMealType,
      }

      return AIPackedPayload

    case "AI_SCAN_NUTRITION_FACTS":
      const nutritionFactPayload: IAINutritionFactPayload = {
        ...getAIScanBasePayload(food, imagePayload),
        source: "AI_SCAN_NUTRITION_FACTS",
        type: logMealType,
      }

      return nutritionFactPayload
  }
}

export default getMealPayloadFromAIScanFoodOption
